<template>
  <el-dialog
    title="薪资设置"
    :visible="staffDialogType == 'salary'"
    :close-on-click-modal="false"
    :before-close="closeDialog"
    @open="initDialog"
    width="50%"
  >
    <div class="base-info">
      <el-form label-position="right" label-width="150px" :model="salaryInfo">
        <el-form-item label="银行名称">
          <el-input v-model="salaryInfo.bank_name"></el-input>
        </el-form-item>
        <el-form-item label="银行卡号">
          <el-input v-model="salaryInfo.bankcard_num"></el-input>
        </el-form-item>
        <el-form-item label="银行卡开户行信息">
          <el-input v-model="salaryInfo.bankcard_info"></el-input>
        </el-form-item>
        <el-form-item label="薪资">
          <el-input v-model="salaryInfo.salary"></el-input>
        </el-form-item>
        <el-form-item label="薪资计算">
          <el-select v-model="salaryInfo.type" placeholder="请选择在职状态">
            <el-option
              v-for="item in SALARY_TYPE"
              :key="item.key"
              :label="item.title"
              :value="item.key"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="社保缴纳">
          <el-input v-model="salaryInfo.social_insurance"></el-input>
        </el-form-item>
        <el-form-item label="公积金">
          <el-input v-model="salaryInfo.housing_fund"></el-input>
        </el-form-item>
        <el-form-item label="基本工资">
          <el-input v-model="salaryInfo.part_a_salary"></el-input>
        </el-form-item>
      </el-form>
      <div class="info-footer">
        <el-button type="success" @click="setSalaryInfo" :loading="isLoading"
          >保 存</el-button
        >
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { managerStaffSalaryInfo, managerSetSalaryInfo } from '@/api/manager'
export default {
  name: 'staff-salsry',
  components: {},
  data() {
    return {
      salaryInfo: {},
      isLoading: false,
    }
  },
  props: ['staffDialogType', 'staffId'],
  methods: {
    closeDialog() {
      this.$emit('update:staffDialogType', '')
    },
    // 获取员工薪资
    async initDialog() {
      let { code, result } = await managerStaffSalaryInfo({
        staff_id: this.staffId,
      })
      if (code == this.CONFIG.CODE_SUCCESS) {
        if (result) {
          result
          this.salaryInfo = result
          return
        }
        this.salaryInfo = {
          bank_name: '',
          bankcard_num: '',
          bankcard_info: '',
          salary: '',
          type: 1,
          social_insurance: '',
          housing_fund: '',
          part_a_salary: '',
        }
      }
    },
    async setSalaryInfo() {
      let postData = { ...this.salaryInfo }
      postData.staff_id = this.staffId
      this.isLoading = true
      let { code, msg } = await managerSetSalaryInfo(postData)
      this.isLoading = false
      if (code == this.CONFIG.CODE_SUCCESS) {
        this.closeDialog()
        this.$message({
          type: 'success',
          message: msg,
        })
      }
    },
  },
}
</script>

<style lang="less" scoped>
.base-info {
  background: #f6f6f6;
  border-radius: 8px;
  padding: 10px;
  margin-bottom: 8px;
}
.info-footer {
  text-align: right;
}
</style>
